import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const TermsProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { userData } = useSelector((state) => state.auth);
  const termsAccepted = userData?.data?.terms_accepted;

  // If we're already on the terms page or login page, render normally to avoid infinite redirects
  if (location.pathname === '/terms' || location.pathname === '/login') {
    return children;
  }

  // If terms_accepted is explicitly false or undefined/null, redirect to terms
  if (termsAccepted === false || termsAccepted === undefined || termsAccepted === null) {
    // Save the current location to redirect back after accepting terms
    return <Navigate to="/terms" replace state={{ from: location }} />;
  }

  // If terms are accepted, render the protected content
  return children;
};

export default TermsProtectedRoute; 